<template>
  <v-container fluid>
    <v-row
      align="center"
      justify="center"
      class="ma-0"
    >
      <v-card
        width="100%"
        elevation="10"
      >
        <v-card-title class="title">
          Novidades
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row
              v-if="isLoading"
              align="center"
            >
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>         
            </v-row>
            <v-row
              v-else
              align="center"
            >
              <v-col
                cols="12"
                md="12"
                lg="12"
                xl="12"
              >
                <v-data-table
                  :headers="headers"
                  :items="news"
                  class="elevation-0"
                  @click:row="showNews"
                  :sort-by="['dh_created']"
                  :sort-desc="[true]"
                >
                  <!-- <template slot="items" slot-scope="props">
                    <tr @click="showNews(props.item)">
                      <td>{{ props.item.title }}</td>
                      <td class="text-xs-right">{{ props.item.dh_created | formatDatetime }}</td>
                    </tr>
                  </template> -->

                  <template v-slot:item.dh_created="{ item }">
                    <span>{{item.dh_created | formatDatetime}}</span>
                  </template>                                     
                </v-data-table>                
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-row>

  </v-container>
</template>

<script>
import moment from 'moment'
import {listNewsUsers} from "@/api/api-news";
import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"

export default {
  name: "ListNews",
  components: {

  },  
  data() {
    return {
      isLoading: false,
      news: [],
      headers: [
        {
          text: 'Título',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        {
          text: 'Criado em',
          align: 'start',
          sortable: true,
          value: 'dh_created',
        },             
      ],      
    }
  },
  filters: {
    formatDatetime(date) {
      return moment(date).format("DD/MM/YYYY hh:mm")
    }      
  },  
  methods: {
    showNews(item) {
      this.$appMng.setIdNews(item.id_mappa_update)
      this.$appMng.setTitleNews(item.title)
      this.$appMng.setContentNews(item.content)
      this.$appMng.setShowNews(true)
    },
    getListNews() {
      this.isLoading = true
      listNewsUsers(this.$apiAuth.getAuthToken())
      .then((res) => {
          this.news = res.data.data
          this.isLoading = false
      })
      .catch(() => {
        this.$notify(new NotificationOptions({
          message: "Não conseguimos obter a lista de novidades.",
          type: NOTIFICATION_TYPES.ERROR,
        }))
        this.isLoading = false
      })    
    }
  },
  mounted() {
    this.getListNews()
  }
}
</script>

<style>
  .ck-content {
    min-height: 200px !important;
  }
</style>